import Splide from '@splidejs/splide';

/**
 * Category page
 */
(() => {
  (() => {
    if (!document.querySelector('.module-category-tabs')) return;
    // create tab titles
    document.querySelectorAll('.module-category-tabs').forEach((item) => {
    // add class to parent if parent has theme-dark class
      if (item.closest('.theme-dark')) {
        item.closest('.theme-dark').classList.add('module-dark-img');
      }

      document.querySelectorAll('.carousel-tab').forEach((tab, i) => {
        // tab wrapper
        const tabContent = document.createElement('div');
        tabContent.className = 'js-tab splide';
        tabContent.setAttribute('tab-id', 0);

        // carousel
        const slider = document.createElement('div');
        slider.className = 'js-carousel-slider carousel-slider splide__track';
        const sliderInner = document.createElement('div');
        sliderInner.className = 'splide__list';

        document.querySelectorAll('.carousel-tab').forEach((carousel, n) => {
          if (i === n) {
            carousel.querySelectorAll('.tile').forEach((tile) => {
              const splideSlide = document.createElement('div');
              splideSlide.className = 'splide__slide';
              splideSlide.append(tile);
              sliderInner.append(splideSlide);
            });
          }
        });
        slider.append(sliderInner);
        tabContent.append(slider);
        const featuredContent = document.querySelector('.js-category-content.featured');
        if (featuredContent) {
          featuredContent.append(tabContent);
        }
        document.querySelector('.js-category-content').append(document.querySelector('.cat-tiles.griditems'));

        // tidy up original merch containers
        tab.closest('.col-sm-12').style.display = 'none';
      });

      item.querySelectorAll('.splide').forEach((splide) => {
        const merchSlider = new Splide(splide, {
          type: 'slide',
          perPage: 5,
          perMove: 1,
          gap: 20,
          pagination: false,
          arrows: true,
          breakpoints: {
            1199: {
              perPage: 3,
            },
            768: {
              perPage: 1,
            },
          },
        });

        // Removes tabindex from all slides outside of view
        const updateTabindex = () => {
          const activeAnchors = splide.querySelectorAll('.splide__slide.is-active a, .splide__slide.is-active button');
          const visibleSlides = splide.querySelectorAll('.splide__slide.is-visible');
          const lastVisibleSlide = visibleSlides[visibleSlides.length - 1];
          const lastVisibleAnchors = lastVisibleSlide ? lastVisibleSlide.querySelectorAll('a, button') : [];

          activeAnchors.forEach((anchor) => {
            anchor.setAttribute('tabindex', -1);
          });

          lastVisibleAnchors.forEach((anchor) => {
            anchor.setAttribute('tabindex', -1);
          });
        };

        merchSlider.on('mounted', () => {
          setTimeout(updateTabindex, 1000);
        });

        merchSlider.on('moved', () => {
          setTimeout(updateTabindex, 1000);
        });

        merchSlider.mount();
      });
    });
  })();
})();
